import React, { createContext, useContext } from 'react';
import { MantineProvider } from '@mantine/core';
import '../cruisingos.css';
import './controls.css';
import { DialogStack } from './Dialog';
import { appTheme } from './theme';

const ScreenContext = createContext(false);

// One app-wide theme and dialog stack also cover React portals. Existing screen
// boundaries reuse the parent provider instead of resetting nested dialog state.
export default function ScreenProvider({ children, env }) {
  const inherited = useContext(ScreenContext);
  if (inherited) return children;
  return <ScreenContext.Provider value={true}><MantineProvider theme={appTheme} forceColorScheme="light" env={env}>
    <DialogStack><div className="tour-ui" style={{ display: 'contents' }}>{children}</div></DialogStack>
  </MantineProvider></ScreenContext.Provider>;
}
